import React, { useState, useRef, useEffect, useCallback, useImperativeHandle } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Modal, Progress, Button } from 'antd';
import { apiHolder as api, apis } from 'api';
import { ModalCloseSmall } from '@web-common/components/UI/Icons/icons';
import IconCard from '@web-common/components/UI/IconCard/index';
import { formatFileSize } from '@web-common/components/util/file';
import { FormatExpiredDate } from '@web-mail/common/components/FormatExpireDate';
const htmlApi = api.api.requireLogicalApi(apis.htmlApi);
import { getIn18Text } from 'api';
import { safeHTML } from '@web-common/utils/xssUtils';
const dataStoreApi = api.api.requireLogicalApi(apis.defaultDataStoreApiImpl);
const SYSTEM_THEME = 'system_theme';
const getSystemTheme = () => {
    const val = dataStoreApi.getSync(SYSTEM_THEME, { noneUserRelated: true });
    if (val && val.suc && val.data) {
        if (val.data !== 'auto') {
            return val.data;
        }
    }
    return window && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};
const getDecodeTitle = (title) => {
    try {
        if (title) {
            const regex = /<\/?b>/g;
            const decoded = htmlApi.decodeHtml(title.replace(regex, ''));
            return decoded;
        }
        return getIn18Text('WUZHUTI');
    }
    catch (e) {
        console.error('[Error reg]', e);
        return getIn18Text('WUZHUTI');
    }
};
function addOrRemovePrintStyle(htmlStr, isAdd) {
    try {
        if (!htmlStr || !htmlStr.length)
            return htmlStr;
        const divEl = document.createElement('div');
        divEl.innerHTML = htmlStr;
        const styleEls = divEl.querySelectorAll('style');
        if (styleEls && styleEls.length) {
            for (let i = 0; i < styleEls.length; i++) {
                const currentStyle = styleEls[i];
                if (!isAdd) {
                    if (currentStyle && currentStyle.media) {
                        if (currentStyle.media === 'print') {
                            currentStyle.media = '';
                        }
                        else if (currentStyle.media.includes(',print')) {
                            currentStyle.media = currentStyle.media.replace(',print', '');
                        }
                    }
                }
                else {
                    if (currentStyle.media) {
                        if (!currentStyle.media.includes('print')) {
                            currentStyle.media += ',print';
                        }
                    }
                    else {
                        currentStyle.media = 'print';
                    }
                }
            }
        }
        return divEl.innerHTML;
    }
    catch (ex) {
        return htmlStr;
    }
}
const printStyle = (theme) => `<style>${theme && theme !== 'dark' ? ':root {--fill-2: #f6f7fa;--white:white;}' : ':root{--fill-2: #232324; --white: #232324;}'}:root{--Brand-6: #4c6aff;}body{margin:0;}.mail-preview{position:fixed;left:0;top:0;bottom:0;right:0;margin:0;padding:0}.mail-preview iframe{width:100%;height:100%;border:0;}.mail-content {display:none;} @media print {@page { margin: 54px; } .mail-content{display:block;} .mail-preview{display:none;}} .title{font-size:14px;color:#262a33;line-height:21px;margin-bottom:16px;font-weight:700;}.print .detail{line-height:14px;margin-bottom:6px;font-size:12px;display:flex;}.print .detail .detail-key{color:#7d8085;width:48px;}.print .detail .detail-val{color:#262a33;flex: 1 1;}.print .content{word-wrap: break-word;margin-top:14px;}.loading-tip{position:absolute;left:0;right:0;top:0;bottom:0;}.loading-header{position:absolute;top:0;left:0;height:44px;right:0;background-color:var(--white,white);}.loading-container{padding-top:56px;display:flex;flex-direction:column;align-items:center;overflow:hidden;background-color: var(--fill-2, #F6F7FA);height:100%;min-width:815px;}.loading-img{width:773px; height:100%;background-color:white;overflow:hidden;padding:15px;position:relative;}.loading-img svg{width:100%;height:100%;}.loading-animation{position:absolute;width:84px;opacity:0.8;left:0;bottom:-100px;top:-100px;transform: rotateZ(10deg);animation-name:leftToRight;animation-timing-function:linear;animation-iteration-count:infinite;animation-duration:2s;background-color:white;filter:blur(30px);}@keyframes leftToRight{from:{left:0px} to {left:1000px}}.lx-theme-dark .dark-invert{filter:invert(100) hue-rotate(180deg);}.print-attachment-item{display:flex;align-items: center;line-height: 22px;font-size: 12px;}.print-attachment-item-info{display:flex;align-items: center;}
  .detail.attachment-container {
    line-height: 22px;
  }
  .print.en .detail .detail-key{width:78px;}
  .print-attachment-item-name {
    color: var(--Brand-6, #4c6aff);
    flex: 1 1 auto;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 540px;
    margin-left: -2px;
    white-space: nowrap;
  }
  .print-attachment-item-download {
    color: var(--Brand-6, #4c6aff);
    margin-left: 24px;
  }
  .print-attachment-item-icon {
    height: 22px;
    transform: scale(0.6);
  }
  .print-cloud-attachments-container {
    border-radius: 8px;
    padding: 12px 0;
    margin-bottom: 20px;
    border: 1px solid var(--Line-2, #ebedf2);
  }
  .print-cloud-attachments-title {
    font-weight: 500;
    line-height: 22px;
    font-size: 14px;
    color: #272e47;
    padding-bottom: 12px;
    padding-left: 12px;
    border-bottom: 1px solid var(--Line-2, #ebedf2);
  }
  .print-cloud-attachments-item {
    display: flex;
    align-items: center;
    padding-top: 12px;
    margin-left: 12px;
    margin-right: 12px;
    padding-bottom: 11px;
    &:not(:last-child) {
      border-bottom: 1px solid var(--Line-2, #ebedf2);
    }
    &:last-child {
      padding-bottom: 0;
    }
  }
  .print-cloud-attachments-item-info {
    margin-left: 12px;
    flex: 1 1 auto;
  }
  .print-cloud-attachments-item-name {
    font-size: 14px;
    line-height: 22px;
    color: #272e47;
    max-width: 540px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .print-cloud-attachments-item-fileinfo {
    font-size: 12px;
    line-height: 20px;
    color: var(--Text-2, #9fa2ad);
  }

  .print-cloud-attachments-item-download {
    color: var(--Brand-6, #4c6aff);
    line-height: 22px;
  }
  </style>`;
const previewFrame = `<div class="mail-preview"><div class="loading-tip"><div class="loading-header"></div><div class="loading-container"><div class="loading-img"><svg viewBox="0 0 752 652" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="752" height="20" rx="4" fill="#F6F7FA"/>
<rect x="92" y="40" width="659" height="16" rx="4" fill="#F6F7FA"/>
<rect x="92" y="72" width="660" height="16" rx="4" fill="#F6F7FA"/>
<rect x="92" y="104" width="659" height="16" rx="4" fill="#F6F7FA"/>
<rect x="92" y="136" width="659" height="16" rx="4" fill="#F6F7FA"/>
<rect y="40" width="80" height="16" rx="4" fill="#F6F7FA"/>
<rect y="72" width="80" height="16" rx="4" fill="#F6F7FA"/>
<rect y="136" width="80" height="16" rx="4" fill="#F6F7FA"/>
<rect y="192" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="288" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="384" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="480" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="576" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="224" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="320" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="416" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="512" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="608" width="752" height="16" rx="4" fill="#F6F7FA"/>
<rect y="256" width="582" height="16" rx="4" fill="#F6F7FA"/>
<rect y="352" width="582" height="16" rx="4" fill="#F6F7FA"/>
<rect y="448" width="582" height="16" rx="4" fill="#F6F7FA"/>
<rect y="544" width="582" height="16" rx="4" fill="#F6F7FA"/>
<rect y="640" width="582" height="16" rx="4" fill="#F6F7FA"/>
</svg><div class="loading-animation"></div></div></div>
</div></div>`;
const printScript = (title, lang, theme) => {
    return `<script>function hideLoading(){const loadingEl = document.querySelector(".loading-tip");loadingEl.style.display = "none";}
  function previewMailByPath(filePath) {
    const siriusFilePath = 'sirius://sirius.file/'+encodeURIComponent(filePath);
    const url = 'sirius://sirius.page/print-mail-preview.html?pdfPath='+ filePath + '&lang=${lang}&theme=${theme}&emailTitle=${encodeURIComponent(title)}';
    const iframeEl = document.createElement("iframe");
    iframeEl.src = url;
    iframeEl.onload = function () {
      hideLoading();
    };
    const mailPreviewEl = document.querySelector(".mail-preview");
    mailPreviewEl.appendChild(iframeEl);
  }
  window.addEventListener("load", function () {
    electronLib.appManage
      .printToPdf({printBackground:true})
      .then((res) => {
        if (!res || !res.filePath) {
          alert("${getIn18Text('PREVIEW_SAVE_ERROR')}");
        }
        const filePath = res.filePath;
        previewMailByPath(filePath);
        if(filePath) {
          window.addEventListener("beforeunload", (ev)=>{
            URL.revokeObjectURL(location.href);
            electronLib.fsManage.remove(filePath);
          });
        }
      })
      .catch((err) => {
        alert("${getIn18Text('PREVIRE_FAILED_RETRY')}");
      });
  });
  </script>`;
};
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const loggerApi = api.api.requireLogicalApi(apis.loggerApiImpl);
const systemApi = api.api.getSystemApi();
let progressTimer = null;
const MailPrint = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const [printProgress, setPrintProgress] = useState(0);
    const [isClosePrint, setClosePrint] = useState(false);
    const [content, setContent] = useState();
    const [modalVisble, setModalVisible] = useState(false);
    const [runHandlePrint, setRunHandlePrint] = useState(false);
    const contentLoading = useRef(false);
    const printRef = useRef(null);
    const [isPreview, setIsPreview] = useState(false);
    const [waterMarkHtml, setWaterMarkHtml] = useState('');
    useEffect(() => {
        if (runHandlePrint) {
            setRunHandlePrint(false);
            if (printRef.current) {
                if (!process.env.BUILD_ISELECTRON || !isPreview) {
                    handlePrint();
                }
                else {
                    handllePrintPreview();
                }
            }
            setIsPreview(false);
        }
    }, [runHandlePrint]);
    const sysTheme = getSystemTheme();
    const handllePrintPreview = async () => {
        if (!printRef.current || !content)
            return;
        const htmlContent = addOrRemovePrintStyle(printRef.current.innerHTML, false);
        const fullHtml = `<html ${sysTheme !== 'dark' ? '' : 'class="lx-theme-dark"'}><head><meta charset="UTF-8"/><title>${getDecodeTitle(content.entry.title || '') || getIn18Text('PRINT_EMAIL_PREVIEW')}</title>${printStyle(sysTheme)}</head>${printScript(getDecodeTitle(content.entry.title || ''), window.systemLang, sysTheme)}<body>${previewFrame}<div class="mail-content print${window.systemLang === 'en' ? ' en' : ''}">${htmlContent}</div></body></html>`;
        const blob = new Blob([fullHtml], { type: 'text/html,charset=UTF-8' });
        const blobUrl = URL.createObjectURL(blob);
        systemApi
            .createWindow({
            type: 'customer',
            url: blobUrl,
        })
            .finally(() => {
            setModalVisible(false);
        });
    };
    const formatReceiver = useCallback(type => {
        const receiver = (content === null || content === void 0 ? void 0 : content.receiver) || [];
        const onReceiver = receiver.filter(item => item.mailMemberType === type);
        return onReceiver.length > 0 ? (React.createElement("p", { className: "detail" },
            React.createElement("span", { className: "detail-key" },
                type === 'to' ? getIn18Text('SHOUJIANREN1') : type === 'cc' ? React.createElement(React.Fragment, null, getIn18Text('CHAO&ems')) : getIn18Text('MI&ems'),
                "\uFF1A"),
            React.createElement("span", { className: "detail-val" }, onReceiver.map((item, index) => {
                var _a;
                const { contactName, accountName } = ((_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contact) || {};
                if (contactName || accountName) {
                    return `${index > 0 ? '、' : ''}${contactName} ${accountName}`;
                }
            })))) : ('');
    }, [content]);
    const onBeforeGetContent = () => {
        setPrintProgress(20);
        progressTimer = setInterval(() => {
            setPrintProgress(data => (data === 80 ? 80 : data + 5));
        }, 1000);
        const bqs = document.querySelectorAll('.foldEle');
        bqs.forEach(element => {
            if (element.nextElementSibling) {
                const nextElementSibling = element.nextElementSibling;
                if (!nextElementSibling || nextElementSibling.id !== 'isReplyContent')
                    return;
                const { className } = nextElementSibling;
                if (className.includes('hid')) {
                    element.style.display = 'none';
                    nextElementSibling.className = className.replace('hid', '');
                    nextElementSibling.style.display = 'block';
                }
            }
        });
        setModalVisible(true);
    };
    const onBeforePrint = () => {
        clearInterval(progressTimer);
        progressTimer = null;
        setPrintProgress(100);
        setTimeout(() => {
            setModalVisible(false);
        }, 200);
        if (isClosePrint) {
            setClosePrint(false);
            return Promise.reject();
        }
        return Promise.resolve();
    };
    const onPrintError = (errorLocation, error) => {
        try {
            loggerApi.track('mail_print_error', { errorLocation: errorLocation, error: error });
        }
        catch (err) {
            console.log('mail_print_error', err);
        }
    };
    const closePrint = () => {
        setClosePrint(true);
        setModalVisible(false);
    };
    const handlePrint = useReactToPrint({
        documentTitle: content === null || content === void 0 ? void 0 : content.entry.title,
        content: () => printRef.current,
        onBeforePrint,
        onBeforeGetContent,
        onPrintError,
    });
    const updateWaterMarkHtml = () => {
        try {
            var divEl = document.querySelector(`div[id^=watermark-]`);
            if (divEl) {
                divEl.style['-webkit-print-color-adjust'] = 'exact';
                setWaterMarkHtml((divEl.outerHTML || '').replace('position: absolute', 'position: fixed'));
            }
            else {
                setWaterMarkHtml('');
            }
        }
        catch (ex) {
            console.error(`updateWaterMarkHtml-catch-error`, ex);
        }
    };
    const getMailContent = useCallback((id, accountId) => {
        return MailApi.doGetMailContent(id, false, false, 'default', { _account: accountId })
            .then((_content) => {
            var _a, _b;
            try {
                loggerApi.track('mail_print', { content: _content });
            }
            catch (error) {
                console.log('mail_print', error);
            }
            if ((_b = (_a = _content === null || _content === void 0 ? void 0 : _content.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content) {
                const printHtmlStr = addOrRemovePrintStyle(_content.entry.content.content, true);
                _content.entry.content.content = printHtmlStr;
            }
            setContent(_content);
        })
            .catch((err) => {
        });
    }, [setContent]);
    const printMail = useCallback((id, accountId, isPreview) => {
        setIsPreview(!!isPreview);
        if (!contentLoading.current) {
            contentLoading.current = true;
            try {
                loggerApi.track('mail_print_click');
            }
            catch (error) {
                console.log('mail_print_click', error);
            }
            try {
                updateWaterMarkHtml();
                getMailContent(id, accountId)
                    .then(() => {
                    setModalVisible(true);
                    setRunHandlePrint(true);
                })
                    .finally(() => {
                    contentLoading.current = false;
                });
            }
            catch (_a) {
                contentLoading.current = false;
                setIsPreview(false);
            }
        }
    }, [getMailContent, handlePrint]);
    useImperativeHandle(ref, () => ({
        printMail: printMail,
    }), [printMail]);
    const hasAttachments = ((_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.length) ? true : false;
    const normalAttachments = !hasAttachments
        ? []
        : content.entry.attachment.filter(item => {
            return item.type === 'url' && !item.inlined;
        });
    const cloudAttachments = !hasAttachments
        ? []
        : content.entry.attachment.filter(item => {
            return item.type === 'netfolder' && !item.inlined;
        });
    const isEnLang = systemApi.getSystemLang() === 'en';
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { footer: null, closable: false, visible: modalVisble, width: "400px", closeIcon: React.createElement(ModalCloseSmall, null) },
            React.createElement("p", { style: { marginBottom: '16px' } }, getIn18Text('ZHENGZAISHENGCHENGYAO')),
            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement(Progress, { percent: printProgress, showInfo: false, status: "active", style: { width: '240px' } }),
                React.createElement(Button, { style: { width: '80px', height: '32px' }, onClick: closePrint }, getIn18Text('QUXIAO')))),
        content ? (React.createElement("div", { className: "printPageBox", style: { display: 'none' } },
            React.createElement("div", { ref: printRef, className: 'print' + (isEnLang ? ' en' : ''), style: { fontSize: '14px', fontFamily: 'arial, verdana, sans-serif, Helvetica, Microsoft Yahei', lineHeight: 1.666, color: '#000' } },
                React.createElement("p", { className: "title" }, getDecodeTitle((content === null || content === void 0 ? void 0 : content.entry.title) || '')),
                React.createElement("p", { className: "detail" },
                    React.createElement("span", { className: "detail-key" }, getIn18Text('FAJIANREN\uFF1A')),
                    React.createElement("span", { className: "detail-val" }, (_e = (_d = (_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 :
                        _e.contactName,
                        "\u00A0", (_h = (_g = (_f = content === null || content === void 0 ? void 0 : content.sender) === null || _f === void 0 ? void 0 : _f.contact) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 :
                        _h.accountName)),
                formatReceiver('to'),
                formatReceiver('cc'),
                React.createElement("p", { className: "detail" },
                    React.createElement("span", { className: "detail-key" }, getIn18Text('SHI&ems')),
                    React.createElement("span", { className: "detail-val" }, (_j = content === null || content === void 0 ? void 0 : content.entry) === null || _j === void 0 ? void 0 : _j.sendTime)),
                normalAttachments && normalAttachments.length ? (React.createElement("div", { className: "detail attachment-container" },
                    React.createElement("span", { className: "detail-key" }, getIn18Text('ATTACHMENT_WITH_SPACE')),
                    React.createElement("div", { className: "print-attachment-items" }, normalAttachments.map(item => {
                        return (React.createElement("div", { className: "print-attachment-item" },
                            React.createElement("div", { className: "print-attachment-item-info" },
                                React.createElement("div", { className: "print-attachment-item-icon" },
                                    React.createElement(IconCard, { type: item.fileType })),
                                React.createElement("div", { className: "print-attachment-item-name" }, item.fileName)),
                            React.createElement("div", { className: "print-attachment-item-download" }, getIn18Text('XIAZAIFUJIAN'))));
                    })))) : null,
                React.createElement("div", { className: "content print-content-wrapper", dangerouslySetInnerHTML: {
                        __html: ((_l = (_k = content === null || content === void 0 ? void 0 : content.entry) === null || _k === void 0 ? void 0 : _k.content) === null || _l === void 0 ? void 0 : _l.content) || '',
                    } }),
                cloudAttachments && cloudAttachments.length ? (React.createElement("div", { className: "print-cloud-attachments-container" },
                    React.createElement("div", { className: "print-cloud-attachments-title" }, getIn18Text('WANGYIQIYYXYFJ')),
                    React.createElement("div", { className: "print-cloud-attachments" }, cloudAttachments.map(item => {
                        return (React.createElement("div", { className: "print-cloud-attachments-item" },
                            React.createElement("div", { className: "print-cloud-attachments-item-icon" },
                                React.createElement(IconCard, { type: item.fileType })),
                            React.createElement("div", { className: "print-cloud-attachments-item-info" },
                                React.createElement("div", { className: "print-cloud-attachments-item-name" }, item.fileName),
                                React.createElement("div", { className: "print-cloud-attachments-item-fileinfo" },
                                    React.createElement("span", { className: "print-cloud-attachments-item-filesize" },
                                        formatFileSize(item.fileSize) || getIn18Text('WEIZHIDAXIAO'),
                                        " | "),
                                    React.createElement("span", { className: "print-cloud-attachments-item-fileexpired" },
                                        React.createElement(FormatExpiredDate, { date: item === null || item === void 0 ? void 0 : item.expired })))),
                            React.createElement("div", { className: "print-cloud-attachments-item-download" }, getIn18Text('XIAZAIFUJIAN'))));
                    })))) : null,
                waterMarkHtml ? React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML(waterMarkHtml) } }) : null))) : (React.createElement(React.Fragment, null))));
});
export default MailPrint;
